import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Api from "../../utils/Api";
import Job from "../../utils/Job";
import Select from 'react-select';
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Machine from "../../utils/entities/Machine";
import {Col, Grid, Row} from 'react-flexbox-grid';
import Timeformat from "../../utils/Timeformat";
import MachineHistory from "./MachineHistory";
import PreviewReportStitches from "../reports/PreviewReportStitches";
import PreviewReportMachinePerformance from "../reports/PreviewReportMachinePerformance";
import MachineDesignHistory from "./MachineDesignHistory";
import MachineStates from "../../utils/MachineStates";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";
import StaticFunctions from "../../utils/StaticFunctions";
import NavPaging from "../../utils/NavPaging";

class MachineDetailView extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.instanceOf(Machine).isRequired,
        machineCounter: PropTypes.number.isRequired
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            sensors: [],
            locations: [],
            machineEditMode: false,
            machineInputError: [],
            machineInputParams: {
                name: props.machine.alias,
                location: props.machine.id_location,
                machineOrder: props.machine.machine_order
            },
            machineCancelParams: {
                name: props.machine.alias,
                location: props.machine.id_location,
                machineOrder: props.machine.machine_order
            },
            historyShow: false,
            historyPage: 0,
            machineInfoShow: false,
            designHistoryShow: false,
            designHistoryPage: 0,
            machine: props.machine,
            performanceChartWidth: 600,
        };

        this.performanceRef = React.createRef();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.displaySensors = ['1.1.1.1.0', '1.1.1.1.1', '1.10.1.0', '1.10.1.3', '1.1.1.1.2'];

        this.updateMachine = this.updateMachine.bind(this);
        this.updateSensors = this.updateSensors.bind(this);
        this.requestCompanyLocations = this.requestCompanyLocations.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.saveSettings = this.saveSettings.bind(this);
        this.saveOldParams = this.saveOldParams.bind(this);
        this.historyPaging = this.historyPaging.bind(this);
        this.designHistoryPaging = this.designHistoryPaging.bind(this);

        this.updateMachineJob = new Job(this.updateMachine, 2000);
        this.updateSensorsJob = new Job(this.updateSensors, 2000);

    }

    componentDidMount() {

        this.updateMachineJob.start(true);
        this.updateSensorsJob.start(true);

        this.requestCompanyLocations();
        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        this.updateMachineJob.stop();
        this.updateSensorsJob.stop();

        window.removeEventListener("resize", this.updateDimensions);

    }

    updateMachine() {

        if (!this.props.machine) return null;

        const params = {
            companyId: this.props.baseData.companies.currentCompany.id,
            machineId: this.props.machine.machine_id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    machine: res
                });
            }
        }.bind(this);

        this.api.request('GetMachine', params, callback, null);

    }

    updateSensors() {

        if (!this.props.machine) return null;

        const params = {
            action: 'sensorLifeData',
            companyId: this.props.baseData.companies.currentCompany.id,
            machineId: this.props.machine.machine_id,
            sensors: this.displaySensors,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    sensors: res
                });
            }
        }.bind(this);

        this.api.request('ReportSensorsOverview', params, callback, null);

    }

    requestCompanyLocations() {

        const params = {
            companyId: this.props.baseData.companies.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    locations: res,
                });
            }
        }.bind(this);

        this.api.request('GetCompanyLocations', params, callback, null);

    }

    updateDimensions() {

        let adjust = () => {
            try {
                this.resizeTimer = 0;
                // try to adjust chart width
                let newWidth = this.performanceRef.current && this.performanceRef.current.offsetWidth > 300 ? this.performanceRef.current.offsetWidth : 300;

                if (newWidth !== this.state.performanceChartWidth) {
                    this.setState({performanceChartWidth: newWidth});
                }
            } catch (e) {
            }
        };

        if (this.resizeTimer === null) adjust();
        if (this.resizeTimer > 0) window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(adjust, 75);

    }

    enterToggleMode(event) {

        if (event.keyCode === 13 || event.keyCode === 27) {
            this.toggleMode();
        }

    }

    toggleMode() {

        if (this.state.machineEditMode) this.setState({machineInputParams: {...this.state.machineCancelParams}});

        this.setState({
            machineEditMode: !this.state.machineEditMode,
            machineInputError: [],
        });

    }

    editInput(event, key) {

        const newInput = {...this.state.machineInputParams};

        newInput[key] = event.target.value;

        this.setState({
            machineInputParams: newInput
        });

    }

    editSelect(event, key) {

        const newInput = {...this.state.machineInputParams};

        newInput[key] = (event) ? event.value : null;

        this.setState({
            machineInputParams: newInput
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.machineInputError) {
            let errorList = this.state.machineInputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    enterSaveSettings(event) {

        if (event.keyCode === 13) {
            this.saveSettings();
        } else if (event.keyCode === 27) {
            this.toggleMode();
        }

    }

    saveSettings() {

        const input = this.state.machineInputParams;
        const machineId = this.props.machine.machine_id;

        if (input && machineId) {
            const params = {
                action: 'saveMachineSettings',
                machineId: machineId,
                name: input.name,
                locationId: input.location,
                companyId: this.props.machine.id_company,
                machineOrder: (this.checkIsAnyAdmin()) ? input.machineOrder : this.props.machine.machine_order
            };

            const callback = function (res) {
                if (res === true) {
                    this.saveOldParams();
                    //this.resetInput();
                    this.toggleMode();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('SaveMachineSettings', params, callback, null);
        }

    }

    saveOldParams() {

        this.setState({machineCancelParams: {...this.state.machineInputParams}});

    }

    setInputError(errorFields) {

        this.setState({
            machineInputError: errorFields,
        });

    }

    setShowHandle(key) {

        if (key === 'machineInfo') {
            this.setState({
                machineInfoShow: !this.state.machineInfoShow
            });
        } else if (key === 'designs') {
            this.setState({
                designHistoryShow: !this.state.designHistoryShow,
                designHistoryPage: 0
            });
        } else if (key === 'history') {
            this.setState({
                historyShow: !this.state.historyShow,
                historyPage: 0
            });
        }

        return false;

    }

    checkIsAnyAdmin() {

        return (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin') || this.props.baseData.checkUserRole('companyadmin'));

    }

    getLocations() {

        //const allLocations = this.props.baseData.locations;
        const allLocations = this.state.locations;

        return allLocations.map(
            (location) => {
                return {
                    label: (location.name) ? location.name : location.id,
                    value: location.id,
                };
            }
        );

    }

    getOrders() {

        const machineCounter = (this.props.machine.machine_order === null) ? (this.props.machineCounter +1) : this.props.machineCounter;
        const options = [];

        for (let i = 0; i < machineCounter; i++) {
            options.push({
                label: i + 1,
                value: i + 1
            });
        }

        return options;

    }

    historyPaging(page) {

        let newPage = page;

        newPage = newPage < 0 ? 0 : newPage;

        this.setState({
            historyPage: newPage
        })

    }

    designHistoryPaging(page) {

        let newPage = page;

        newPage = newPage < 0 ? 0 : newPage;

        this.setState({
            designHistoryPage: newPage
        })

    }

    getSensorGrid() {

        if (this.state.sensors.length === 0) return null;

        const sensors = this.state.sensors;
        const sensorBlock = [];

        sensors.forEach(
            (sensorData) => {
                let nameKey = sensorData.nameKey;
                let dataValue = StaticFunctions.formatedNumber(sensorData.dataValue.replace('.', ','));
                let unitKey = sensorData.unitKey;

                sensorBlock.push(
                    <tr key={'sensor-' + nameKey}>
                        <td className="text-left labelSpan">{this.translate(nameKey)}</td>

                        <td className="text-left">
                            <input
                                name="temperature"
                                type="text"
                                value={dataValue + ' ' + unitKey}
                                disabled={true}
                            />
                        </td>
                    </tr>
                );
            }
        );

        return (
            <Col xs={12} xl={4} className="formSettings">
                <div>
                    <nav className="clearfix">
                        <h1>{this.translate('sensors')}</h1>
                    </nav>
                </div>

                <div className="formRow">
                    <table>
                        <tbody>
                            {sensorBlock}
                        </tbody>
                    </table>
                </div>
            </Col>
        );

    }

    getMachineInfoGrid() {

        if (this.state.machineInfoShow) {
            const m = this.state.machine;
            const machineHeads = StaticFunctions.getMachineHeads(m);

            return (
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <nav>
                                <h1 onClick={() => this.setShowHandle('machineInfo')} style={{cursor: 'pointer'}}>{this.translate('detailsMachine')}</h1>

                                <img src={require('../../img/pages/datatables/sort_asc_disabled.svg').default}
                                     alt=""
                                     style={{cursor: 'pointer', float: 'left', height: '30px', width: '30px'}}
                                     onClick={() => this.setShowHandle('machineInfo')}
                                />
                            </nav>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={4} className="formSettings">
                            <div className="formRow">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('heads')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="heads"
                                                    type="text"
                                                    value={machineHeads}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('needles')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="heads"
                                                    type="text"
                                                    value={m.needles}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('rpm')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="rpm"
                                                    type="text"
                                                    value={StaticFunctions.formatedNumber(m.rpm)}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>

                        <Col xs={4} className="formSettings">
                            <div className="formRow">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('osVersion')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="osVersion"
                                                    type="text"
                                                    value={(m.t8_os_version && m.t8_os_version !== '-1') ? m.t8_os_version : '-'}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('tsVersion')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="tsVersion"
                                                    type="text"
                                                    value={(m.t8_ts_version && m.t8_ts_version !== '-1') ? m.t8_ts_version : '-'}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-left labelSpan">{this.translate('cpuVersion')}</td>

                                            <td className="text-left">
                                                <input
                                                    name="cpuVersion"
                                                    type="text"
                                                    value={(m.cpu_version && m.cpu_version !== '-1') ? m.cpu_version : '-'}
                                                    disabled={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            );
        } else {
            return (
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <nav>
                                <h1 onClick={() => this.setShowHandle('machineInfo')} style={{cursor: 'pointer'}}>{this.translate('detailsMachine')}</h1>

                                <img src={require('../../img/pages/datatables/sort_desc_disabled.svg').default}
                                     alt=""
                                     style={{cursor: 'pointer', float: 'left', height: '30px', width: '30px'}}
                                     onClick={() => this.setShowHandle('machineInfo')}
                                />
                            </nav>
                        </Col>
                    </Row>
                </Grid>
            );
        }

    }

    getDesignsGrid() {

        if (this.state.designHistoryShow) {
            return (
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <nav>
                                <h1 onClick={() => this.setShowHandle('designs')} style={{cursor: 'pointer'}}>{this.translate('designs')}</h1>

                                <img src={require('../../img/pages/datatables/sort_asc_disabled.svg').default}
                                     alt=""
                                     style={{cursor: 'pointer', float: 'left', height: '30px', width: '30px'}}
                                     onClick={() => this.setShowHandle('designs')}
                                />

                                <NavPaging
                                    translate={this.translate}
                                    changePage={this.designHistoryPaging}
                                />
                            </nav>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <MachineDesignHistory
                                baseData={this.props.baseData}
                                machine={this.state.machine}
                                page={this.state.designHistoryPage}
                                maxRows={10}
                            />
                        </Col>
                    </Row>
                </Grid>
            );
        } else {
            return (
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <nav>
                                <h1 onClick={() => this.setShowHandle('designs')} style={{cursor: 'pointer'}}>{this.translate('designs')}</h1>

                                <img src={require('../../img/pages/datatables/sort_desc_disabled.svg').default}
                                     alt=""
                                     style={{cursor: 'pointer', float: 'left', height: '30px', width: '30px'}}
                                     onClick={() => this.setShowHandle('designs')}
                                />
                            </nav>
                        </Col>
                    </Row>
                </Grid>
            );
        }

    }

    getHistoryGrid() {

        if (this.state.historyShow) {
            return (
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <nav>
                                <h1 onClick={() => this.setShowHandle('history')} style={{cursor: 'pointer'}}>{this.translate('history')}</h1>

                                <img src={require('../../img/pages/datatables/sort_asc_disabled.svg').default}
                                     alt=""
                                     style={{cursor: 'pointer', float: 'left', height: '30px', width: '30px'}}
                                     onClick={() => this.setShowHandle('history')}
                                />

                                <NavPaging
                                    translate={this.translate}
                                    changePage={this.historyPaging}
                                />
                            </nav>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <MachineHistory
                                baseData={this.props.baseData}
                                machine={this.state.machine}
                                page={this.state.historyPage}
                                maxRows={10}
                            />
                        </Col>
                    </Row>
                </Grid>
            );
        } else {
            return (
                <Grid fluid>
                    <Row>
                        <Col xs={12}>
                            <nav>
                                <h1 onClick={() => this.setShowHandle('history')} style={{cursor: 'pointer'}}>{this.translate('history')}</h1>

                                <img src={require('../../img/pages/datatables/sort_desc_disabled.svg').default}
                                     alt=""
                                     style={{cursor: 'pointer', float: 'left', height: '30px', width: '30px'}}
                                     onClick={() => this.setShowHandle('history')}
                                />
                            </nav>
                        </Col>
                    </Row>
                </Grid>
            );
        }

    }

    getButtons() {

        if (this.state.machineEditMode) {
            return (
                <span>
                    <a className="formButton" tabIndex="4" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('cancel')}
                    </a>

                    <a className="formButton" tabIndex="5" onClick={() => this.saveSettings()} onKeyDown={(event) => this.enterSaveSettings(event)}>
                        {this.translate('save')}
                    </a>
                </span>
            );
        } else {
            return (
                <span>
                    <a className="formButton" tabIndex="4" onClick={() => this.toggleMode()} onKeyDown={(event) => this.enterToggleMode(event)}>
                        {this.translate('edit')}
                    </a>
                </span>
            );
        }

    }

    render() {

        if (!this.state.machine) return <LoadingSplash color={'dark'}/>;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const m = this.state.machine;
        const machineHeads = StaticFunctions.getMachineHeads(m);
        const lastSeen = (m.last_seen > 0) ? Timeformat.fromUnix(m.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
        const lastOperation = (m.last_operation > 0) ? Timeformat.fromUnix(m.last_operation).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        let location = parseInt(m.id_location, 10);

        if (this.props.baseData.locations) {
            location = this.props.baseData.locations.find((l) => {
                return parseInt(l.id, 10) === location;
            });

            location = location ? location.name : '';
        }

        //const rotation_speed = m.rotation_speed;
        const statusClass = MachineStates.getStatusType(m.status);
        const statusClasses = ['status', statusClass].join(' ').trim();
        const state = MachineStates.get(m.status);
        const stateKey = state ? state.translationKey : m.status;
        const pattern_stitchcounter = m.pattern_stitchcounter; // total stitches in current pattern
        const pattern_stitchnumber = (stateKey === 'status_1012') ? m.pattern_stitchcounter : m.pattern_stitchnumber;

        const sensorsGrid = this.getSensorGrid();
        const machineInfoGrid = this.getMachineInfoGrid();
        const designsGrid = this.getDesignsGrid();
        const historyGrid = this.getHistoryGrid();

        const locations = this.getLocations();
        const orders = this.getOrders();

        const disabled = !this.state.machineEditMode;
        const disabled2 = (this.checkIsAnyAdmin()) ? disabled : true;

        const buttons = this.getButtons();

        const colXl = (sensorsGrid === null) ? 6 : 4;

        return (
            <Grid fluid>
                <Row>
                    {/*Machine*/}
                    <Col xs={12} xl={colXl} className="formSettings">
                        <div>
                            <nav className="clearfix">
                                <h1>{this.translate('machine')}</h1>
                            </nav>
                        </div>

                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('status')}</td>

                                        <td className="text-left">
                                            <span className={statusClasses}>
                                                <i>{statusClass}</i> {this.translate(stateKey)}
                                            </span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('id')}</td>

                                        <td className="text-left">
                                            <input
                                                name="machineId"
                                                type="text"
                                                value={m.machine_id}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('name')}</td>

                                        <td className="text-left">
                                            <input
                                                name="name"
                                                className={this.checkInputError('name')}
                                                type="text"
                                                tabIndex="1"
                                                value={this.state.machineInputParams.name}
                                                disabled={disabled}
                                                onChange={(event) => this.editInput(event, 'name')}
                                                onKeyDown={(event) => this.enterSaveSettings(event)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('location')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="locations"
                                                className={['chosen-container', 'chosen-container-single', this.checkInputError('locations')].join(' ').trim()}
                                                style={{width: '260px'}}
                                                options={locations}
                                                tabIndex="2"
                                                value={locations.find(o => String(o.value) === String(this.state.machineInputParams.location)) || null}
                                                placeholder={this.translate('select') + '...'}
                                                clearable={false}
                                                noResultsText={this.translate('noResultsFound')}
                                                disabled={disabled}
                                                onChange={(event) => this.editSelect(event, 'location')}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('order')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="machineOrder"
                                                className={['chosen-container', 'chosen-container-single', this.checkInputError('machineOrder')].join(' ').trim()}
                                                style={{width: '260px'}}
                                                options={orders}
                                                tabIndex="3"
                                                value={orders.find(o => String(o.value) === String(this.state.machineInputParams.machineOrder)) || null}
                                                placeholder={this.translate('select') + '...'}
                                                clearable={true}
                                                noResultsText={this.translate('noResultsFound')}
                                                disabled={disabled2}
                                                onChange={(event) => this.editSelect(event, 'machineOrder')}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('stitches')} / {this.translate('design')}</td>

                                        <td className="text-left">
                                            <input
                                                name="stitchesPattern"
                                                type="text"
                                                value={StaticFunctions.formatedNumber(pattern_stitchnumber) + ' / ' + StaticFunctions.formatedNumber(pattern_stitchcounter)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('lastTransmission')}</td>

                                        <td className="text-left">
                                            <input
                                                name="lastSeen"
                                                type="text"
                                                value={(lastSeen) ? lastSeen : '-'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('lastStitched')}</td>

                                        <td className="text-left">
                                            <input
                                                name="lastOperation"
                                                type="text"
                                                value={(lastOperation) ? lastOperation : '-'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan webElement">&nbsp;</td>

                                        <td className="text-left">{buttons}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Col>
                    {/*Machine*/}

                    {/*Sensors*/}
                    {sensorsGrid}
                    {/*Sensors*/}

                    {/*Design*/}
                    <Col md={12} xl={colXl}>
                        <div>
                            <nav className="clearfix">
                                <h1>{this.translate('design')}</h1>
                            </nav>

                            <div style={{textAlign: 'center'}}>
                                <DesignPreviewContainer
                                    baseData={this.props.baseData}
                                    designId={m.pattern_number}
									designStitches={m.pattern_stitchcounter}
                                    styles={{margin: '0 auto', height: 'auto', width: '200px'}}
                                />
                            </div>

                            <div style={{textAlign: 'center'}}>
                                {m.pattern_number}
                            </div>
                        </div>
                    </Col>
                    {/*Design*/}

                    {/*Machineinfos*/}
                    <Col xs={12} style={{paddingTop: 10}}>
                        {machineInfoGrid}
                    </Col>
                    {/*Machineinfos*/}

                    {/*Reports*/}
                    <Col xs={12} style={{paddingTop: 10}}>
                        <Grid fluid>
                            <Row>
                                <Col xs={12}>
                                    <nav>
                                        <h1>{this.translate('reports') + ' (' + this.translate('lastTwoWeeks') + ')'}</h1>
                                    </nav>
                                </Col>

                                <Col xs={12} lg={12} xl={6}>
                                    <div className="chartBox" style={{border: 'none'}}>
                                        <PreviewReportStitches
                                            baseData={this.props.baseData}
                                            machine={this.props.machine}
                                            height={400}
                                        />
                                    </div>
                                </Col>

                                <Col xs={12} lg={12} xl={6}>
                                    <div className="chartBox" ref={this.performanceRef} style={{border: 'none'}}>
                                        <PreviewReportMachinePerformance
                                            header={this.translate('machinePerformance')}
                                            baseData={this.props.baseData}
                                            machine={this.props.machine}
                                            height={Math.round(this.state.performanceChartWidth * 0.5)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </Col>
                    {/*Reports*/}

                    {/*Designs*/}
                    <Col md={12} style={{paddingTop: 10}}>
                        {designsGrid}
                    </Col>
                    {/*Designs*/}

                    {/*History*/}
                    <Col md={12} style={{paddingTop: 10}}>
                        {historyGrid}
                    </Col>
                    {/*History*/}
                </Row>
            </Grid>
        );

    }

}

export default MachineDetailView;
